export default __webpack_public_path__ + "static/media/logout-dark.e6943779.svg";